import React from 'react';
import styles from './styles.module.css';

export default function HoverTooltip({ content, anchorPercent = 50, anchorProgress, thumbPx = 28, offsetY = -12, className = '', children }) {
  const percent = Math.max(0, Math.min(100, anchorPercent));
  const progress = typeof anchorProgress === 'number' ? Math.max(0, Math.min(1, anchorProgress)) : percent / 100;
  const style = {
    '--anchor-x': `${percent}%`, // legacy/fallback
    '--progress': progress,
    '--thumb': `${thumbPx}px`,
    '--offset-y': `${offsetY}px`,
  };

  return (
    <div className={`${styles.wrapper} ${className}`} style={style}>
      <div className={styles.anchor}>{children}</div>
      <div className={styles.tooltip} role="tooltip">
        <div className={styles.tooltipInner}>{content}</div>
        <div className={styles.arrow} />
      </div>
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/views/v2/common/Tooltip/index.jsx